/**
 * null, undefined, emptyのチェック
 * @param str 判定対象の文字列
 * @returns {boolean}
 */
export const isNullOrUndefinedOrEmpty = (str) => str === null || str === undefined || str === '';
